module.exports = __webpack_public_path__ + "img/asset-05.72c965cb.svg";